import { useState } from "react";
import { faqs } from "@/mocks/gossip";
import { SectionHeading } from "./SectionHeading";

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState<number>(0);

  return (
    <section id="faq" className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-20 lg:px-10">
      <div className="grid grid-cols-1 gap-8 lg:grid-cols-3">
        <div className="lg:sticky lg:top-24 lg:self-start">
          <SectionHeading
            kicker="常见问题"
            title="关于吃瓜大全，你想知道的"
            desc="对完整存档、信源标注、更新机制有疑问？这里汇总了读者最常问的几个问题。"
          />
          <div className="mt-6 rounded-2xl border border-accent-200 bg-accent-50 px-5 py-4">
            <div className="flex items-center gap-2 text-sm font-semibold text-accent-900">
              <i className="ri-chat-smile-3-line text-lg"></i>
              还有别的问题？
            </div>
            <p className="mt-1.5 text-sm leading-relaxed text-accent-900/90">
              欢迎通过页脚的提交入口告诉我们，或把你的疑问与关注的事件一起发给编辑部。
            </p>
          </div>
        </div>

        <div className="lg:col-span-2">
          <div className="space-y-3">
            {faqs.map((f, i) => {
              const open = openIndex === i;
              return (
                <div
                  key={i}
                  className={
                    "overflow-hidden rounded-2xl border transition-colors " +
                    (open ? "border-primary-200 bg-background-100" : "border-background-200 bg-background-50")
                  }
                >
                  <button
                    onClick={() => setOpenIndex(open ? -1 : i)}
                    aria-expanded={open}
                    className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left"
                  >
                    <span className="flex items-center gap-3 text-sm font-semibold text-foreground-950 md:text-base">
                      <span
                        className={
                          "flex h-6 w-6 shrink-0 items-center justify-center rounded-full text-xs font-bold " +
                          (open ? "bg-primary-500 text-background-50" : "bg-secondary-100 text-secondary-900")
                        }
                      >
                        Q{i + 1}
                      </span>
                      {f.q}
                    </span>
                    <span
                      className={
                        "flex shrink-0 items-center justify-center text-lg transition-transform duration-300 " +
                        (open ? "rotate-45 text-primary-500" : "text-foreground-400")
                      }
                    >
                      <i className="ri-add-line"></i>
                    </span>
                  </button>
                  <div
                    className={
                      "grid transition-all duration-300 " + (open ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0")
                    }
                  >
                    <div className="overflow-hidden">
                      <div className="px-5 pb-5 pl-14">
                        <p className="text-sm leading-relaxed text-foreground-600">{f.a}</p>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}